const Divider = () => (
    <div className="h-6 border-l border-gray-300 mx-2"></div>
);

export default Divider;